import React, { useState } from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Layouts/Spinner";
import { addCatagoriesValidation } from "../../Constant/constant";
import { addNewCategories } from "../../../redux/categories/action";

const AddCategories = () => {
  const [loading, setLoading] = useState(false);
  const [selectStatus, setSelectStatus] = useState("");
  const [selectPosition, setSelectPosition] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      status: 0,
      position:1|| "",
      ar_title: "",
    },
    validationSchema: addCatagoriesValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
    };
    dispatch(addNewCategories(data, setLoading, navigate));
  };

  const handleChangeStatus = (e) => {
    const gender = e.target.value;
    setSelectStatus(gender);
    formik.setFieldValue("status", Number(gender));
  };
  const handleChangePosition = (e) => {
    const pos = e.target.value;
    setSelectPosition(pos);
    formik.setFieldValue("position", Number(pos));
  };

  return (
    <div className="p-3">

      <div className=" category-wrapper">
        <h3 className="pb-3">Add Category</h3>
        <form onSubmit={formik.handleSubmit}>
          <div className="row ">
            <div className="col-md-4 form-group">
              <label>Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter category title"
                name="title"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.title}
              />
              {formik.touched.title && formik.errors.title ? (
                <div className="error">{formik.errors.title}</div>
              ) : null}
            </div>

            <div className="col-md-4 form-group">
              <label>Ar Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter ar title"
                name="ar_title"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.ar_title}
              />
              {formik.touched.ar_title && formik.errors.ar_title ? (
                <div className="error">{formik.errors.ar_title}</div>
              ) : null}
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="status">Position</label>
              <select
                id="position"
                title="position"
                className="form-control"
                onChange={handleChangePosition}
                onBlur={formik.handleBlur}
                value={formik.values.position}
              >
             {Array.from({ length: 50 }, (_, i) => i + 1).map(
                        (num) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        )
                      )}
              </select>
              {formik.touched.position && formik.errors.position ? (
                <div className="error">{formik.errors.position}</div>
              ) : null}
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="status">Status</label>
              <select
                id="status"
                title="status"
                className="form-control"
                onChange={handleChangeStatus}
                onBlur={formik.handleBlur}
                value={formik.values.status}
              >
                <option value="">Select Status</option>
                <option value="1">Active</option>
                <option value="2">Inactive</option>
              </select>
              {formik.touched.status && formik.errors.status ? (
                <div className="error">{formik.errors.status}</div>
              ) : null}
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center mt-3  "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn  "
              onClick={() => {
                navigate("/categories");
              }}
              style={{ width: "max-content" }}
            >
              Back
            </button>
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Submit" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCategories;
